import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { mainModule } from './main';
import { State } from './state';
import { mainStateKeys } from './main/state';

Vue.use(Vuex);

const storeOptions: StoreOptions<State> = {
  plugins: [
    createPersistedState({
      // Keep this updated with the MainState interface
      // to avoid persisting outdated keys.
      paths: mainStateKeys.map((key) => `main.${key}`),
    }),
  ],
  modules: {
    main: mainModule,
  },
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
